import React, { useEffect } from "react";
import { Container } from "@mui/material";
import { useCookies } from 'react-cookie';

function NotAllowed({systemData}) {
    /** COOKIES */
    const [cookies, setCookie, removeCookie] = useCookies(['login-kiwox-cookies']);

    const backgroundImageStyle = {
        backgroundImage: `url(${systemData.bg_image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    };

    useEffect(() => {
        /*
        if (cookies['login-kiwox-cookies-token'] && cookies['login-kiwox-cookies-redirect'])
            checkLogin(cookies['login-kiwox-cookies-token'])
        */
    });

    return (
        <div className="bg-login" style={backgroundImageStyle}>
            <Container className="d-flex justify-content-center pt-5" component="main">
                Not Allowed sorry not sorry!!!
            </Container>
        </div>
    );
}

export default NotAllowed;
